const {
	getsearchresexp,
	getsearchresskl,
	addevaluator,
	addsearchresskl,
	addsearchresexp,
	updateEval,
} = require("../../utils/apiFunctions");

const {
	checkAddResponse,
	checkUpdateResponse,
	validData,
} = require("../evaluators/helpers");

export const searchExp = async (vueObj) => {
	try {
		if (!vueObj.firstload) {
			vueObj.searchexp = vueObj.searchexp.trim();
		}

		const res = await getsearchresexp(vueObj.searchexp);
		if (res.status == 200) {
			vueObj.searchexpres = res.data.data;
		}
	} catch (error) {
		throw new Error(`Failed! status: ${error.status}`);
	}
	vueObj.firstload = false;
};

export const searchSkl = async (vueObj) => {
	try {
		if (!vueObj.firstload) {
			vueObj.searchskl = vueObj.searchskl.trim();
		}

		const res = await getsearchresskl(vueObj.searchskl);
		if (res.status == 200) {
			vueObj.searchsklres = res.data.data;
		}
	} catch (error) {
		throw new Error(`Failed! status: ${error.status}`);
	}
	vueObj.firstload = false;
};

export const addEditEvaluator = async (type, vueObj) => {
	vueObj.LoaderStatus = true;
	vueObj.$v.$touch();
	// Checks FOR the validations
	if (vueObj.$v.$error) {
		vueObj.LoaderStatus = false;
		vueObj.errorToast("Please fill all the mandatory fields");
	} else if (validData(vueObj)) {
		vueObj.aoetags.expertise = vueObj.aoeoptiontags;
		vueObj.skillstags.skill = vueObj.skilloptionstag;
		let aoegrid = [];
		let temp = {
			name: "",
			code: "",
		};
		for (let i of vueObj.aoeoptiontags) {
			temp.name = i;
			temp.code = i;
			aoegrid.push(temp);
			temp = {
				name: "",
				code: "",
			};
		}
		let skillgrid = [];
		for (let j of vueObj.skilloptionstag) {
			temp.name = j;
			temp.code = j;

			skillgrid.push(temp);
			temp = {
				name: "",
				code: "",
			};
		}
		let evaldata = {};
		if (type == "add") {
			evaldata["portion"] = "Evaluator";
			evaldata["name"] = vueObj.eval.name;
			evaldata["phoneNumber"] = vueObj.eval.phoneNumber;
			evaldata["email"] = vueObj.eval.email;
			evaldata["skills"] = skillgrid;
			evaldata["areaOfExpertise"] = aoegrid;
			try {
				const res = await addevaluator(evaldata);
				checkAddResponse(res, vueObj);
			} catch (error) {
				vueObj.LoaderStatus = false;
				vueObj.errorToast("Something went wrong!");
				return error;
			}
		} else if (type == "edit") {
			evaldata["evaluatorID"] = vueObj.eval.evaluatorID;
			evaldata["name"] = vueObj.eval.name;
			evaldata["phoneNumber"] = vueObj.eval.phoneNumber;
			evaldata["email"] = vueObj.eval.email;
			evaldata["skills"] = skillgrid;
			evaldata["areaOfExpertise"] = aoegrid;

			try {
				const res = await updateEval(evaldata);

				checkUpdateResponse(res, vueObj);
			} catch (error) {
				vueObj.LoaderStatus = false;
				vueObj.errorToast("Something went wrong!");
				throw new Error(`Failed! Status:${error.status}`);
			}
		}
		checkResponse(vueObj);
	}
};

const checkResponse = async (vueObj) => {
	let responseexp, responseskl;
	try {
		await addsearchresexp(vueObj.aoetags).then((res) => {
			responseexp = res;
		});
		await addsearchresskl(vueObj.skillstags).then((res) => {
			responseskl = res;
		});
	} catch (error) {
		if (responseexp.status != 200 || responseskl.status != 200) {
			vueObj.errorToast(error.response.data.data.Data);
			throw new Error(`Failed! Status:${error.status}`);
		}
	}
};
